import { Grid, Stack } from '@mui/material'
import { GItem } from '../components/common/grids'
import { SubTitle } from '../components/common/subTitle'
import { ErrorMessageCard } from '../components/common/errorMessageCard'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { ButtonOutlinedWarningL } from '../components/common/buttons/buttonOutlinedWarningL'
import { BackButton } from '../components/common/buttons/backButton'
import { Form } from '../components/common/inputs/form'
import { FlexibleCheckBoxesUnit } from '../components/common/memberModifyChild/flexibleCheckBoxesUnit'
import { translate } from '../../i18n'
import { useAction } from '../../containers/memberModifyChildPredisposition/memberModifyChildPredispositionService'

export const MemberModifyChildPredisposition = () => {
  const {
    CATEGORY_KEY,
    formMethods,
    categoryMst,
    onSubmit,
    childrenResultCode,
  } = useAction()
  
  const targetCategories = categoryMst?.filter((value) => CATEGORY_KEY.includes(value.category))
  return (
    <Form formMethods={formMethods} onSubmit={onSubmit}>
      <Stack spacing={2}>
        <Grid container>
          <Grid item md={3}></Grid>
          <Grid item xs={12} md={6}>
            <Stack spacing={2}>
              {targetCategories != null && targetCategories.length > 0 ?
                (<>
                  <SubTitle title={'体質・くせ'} />
                  {
                    targetCategories.map((mst) => {
                      switch(mst?.category){
                        case "predisposition":
                          return (
                            <GItem xs={7} sm={10}>
                            <FlexibleCheckBoxesUnit
                              categoryMst = {mst}
                              indentOff = {false}
                            />
                            </GItem>
                          )
                        default:
                          return null
                      }
                    })
                  }
                </>)
                :
                (<>
                  {translate('memberModifyChildPredisposition.error.noCategoryMst')}
                </>)
              }
            </Stack>
          </Grid>
        </Grid>
        {!!childrenResultCode && (
          <ErrorMessageCard
            messages={[translate(`memberModifyConfirmationChild.error.childrenResultCode${childrenResultCode}`)]}
          />
        )}
        <BottomButtonGroup>
          <ButtonOutlinedWarningL fullWidth type="submit">
            {translate('memberModifyChildPredisposition.button.decision')}
          </ButtonOutlinedWarningL>
          <BackButton />
        </BottomButtonGroup>
      </Stack>
    </Form>
  )
}
